
import React, { useState, useEffect, useContext, useRef } from "react";
import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";
import Sidebar from "../components/dashboard/sidebar";
import { useNavigate, Link } from "react-router-dom";
import { useParams } from 'react-router-dom';
import SideMenu from "./student/SideMenu";

import tmdbApi from "../api/tmdbApi";
import axios from 'axios';
import moment from "moment";
import Editor from 'react-simple-wysiwyg';
import Select from 'react-select';
import Loader from "../components/loader";
import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../context/contentContext";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { v4 as uuid } from 'uuid';
import { Uploader } from "../utils/upload"
import SessionPopup from "./SessionPopup"
import { LazyLoadImage } from "react-lazy-load-image-component";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import "react-lazy-load-image-component/src/effects/blur.css";
import OpenSeadragon from "openseadragon";
import rotateIconorange from "../assets/images/rotate_right-1.svg"

import progessIcon from "../assets/images/icons/progess.png";
import loadingIcon from "../assets/images/icons/loading.png";
import doneIcon from "../assets/images/icons/upload-done.png";
import deepZoom from "../assets/images/icons/Dna-dz.svg";


let { lambda, country, appname } = window.app;
const getYouTubeVideoId = (url) => {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url?.match(regExp);
    return match && match[7].length === 11 ? match[7] : null;
};
const customComponents = {
    DropdownIndicator: () => null, // Remove the dropdown indicator
    IndicatorSeparator: () => null, // Optionally remove the separator
};

const EditQuiz = () => {
    const transformRef = useRef(null);
    const viewerRef = useRef(null);

    const inputRef = useRef(null);

    let { id } = useParams();
    const navigate = useNavigate();
    const [msg, setMsg] = useState("");



    const [baseUrl, setBaseUrl] = useState("https://qih3mm5tl8.execute-api.ap-south-1.amazonaws.com/prod/")
    const [partsize, setPartsize] = useState(100)
    const [numuploads, setNumuploads] = useState(3)
    const [ta, setTa] = useState(undefined)
    const [pgvalue, setPgvalue] = useState(undefined)
    const [perf, setPerf] = useState(undefined)

    const [quizError, setQuizError] = useState('');
    const [costError, setCostError] = useState('');
    const [descriptionError, setdescriptionError] = useState('');
    const [statusError, setstatusError] = useState('');
    const [explanationError, setexplanationError] = useState('');
    const [tagError, settagError] = useState('');
    const [answer1Error, setanswer1Error] = useState('');
    const [answer2Error, setanswer2Error] = useState('');
    const [formData, setFormData] = useState('');

    const [caseIdDynamic, setCaseId] = useState(null);

    const [isLoading, setIsLoading] = useState(false);
    const [isUserAdd, setIsUserAdd] = useState(false);
    const [feeError, setFeeError] = useState('');
    const [nameError, setNameError] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [IdcError, setIdcError] = useState('');
    const [typeError, setTypeError] = useState('');
    const [toastMessage, setToastMessage] = useState(""); // State for dynamic message
    const [managertypeError, setManagerTypeError] = useState('');
    const [editUser, setEditUser] = useState({ diagnosis: '', clinicalhistory: '', youtube: '', tag: '', explanation: '', answer1: '', answer2: '', answer11: '' });
    const [permission, setPermission] = useState({});
    const [completedFiles, setCompletedFiles] = useState([]);
    
    const [success, setSuccess] = useState(false);

    const [UpdateSuccess, setUpdateSuccess] = useState(false);
    const [image, setImg] = useState('');
    const [imageCloudfront, setimageCloudfront] = useState('');

    const [manager, setManagers] = useState({});
    const [selectAll, setSelectAll] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [existmsg, setExistMsg] = useState(false);
    const [Ismsg, setIsMsg] = useState(false);

    const [imageErrorFiles, setImageErrorFiles] = useState([])
    const [fileSizeError, setFileSizeError] = useState(false);
    const [fileSizeErrorMsg, setFileSizeErrorMsg] = useState("");
    const [inputChange, setInputChange] = useState(true);
    const [questionData, setQuestionData] = useState(null);
    const [imagedisplay, setImageDisplay] = useState(false);
    const [resourceBucket, setResourceImg] = useState(false);

    const [toggleClearRows, setToggleClearRows] = useState(false);
    const [imagesUrls, setImageUrls] = useState(null);
    const [imageFiles, setImageFiles] = useState([])
    const [imageIndex, setImageIndex] = useState(0)
    const [alertPopup, setAlertPopup] = useState(false)
    const [deleteImage, setdeleteImage] = useState(false);
    const [deleteImageId, setDeleteImageId] = useState(null);
    const [deleteImageSuccess, setDeleteImageSuccess] = useState(false);
    const [successAPI, setSuccessAPI] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");
    
    const [uploadImg, setUploadImg] = useState(false);
    const [deleteimageType, setImageType] = useState(null);

    const [clinicalimageFiles, setclinicalImageFiles] = useState([])
    const [clinicalimagesUrls, setClinicalImageUrls] = useState(null);
    const [clinicalimageIndex, setClinicalImageIndex] = useState(0)

    const [uploadedFiles, setUploadedFiles] = useState([])

    const [cpcList, setCPCInfo] = useState([])

    // Deepzoom
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
    const [dziUrl, setDziUrl] = useState("");
    const [dziUrlFile, setDziUrlFile] = useState("");

    const [dzipopupImage, setDZIPopupImage] = useState(false);
    const [isPopupLoading, setPopupLoading] = useState(false);
    const [viewer, setViewer] = useState(null);
    const [resetpopup, setresetpopup] = useState(false);
    const [rotation, setRotation] = useState(0);



    const [files, setFiles] = useState([]);
    const [tags, setTags] = useState([]);
    const [input, setInput] = useState("");
    const [showVideoPopup, setShowVideoPopup] = useState(false);
    const [showImagePopup, setShowImagePopup] = useState(false);
    const [popupImage, setPopupImage] = useState(null);
    const [answers, setAnswersData] = useState(null);
    const [filteredOptionsMap, setFilteredOptionsMap] = useState({});




    const [checkStatus, setCheckStatus] = useState(false);
    const [invalidContent, setInvalidContent] = useState(false);
    const { route, setRoute, setCurrentPage, setRowsPerPage, setActiveMenuObj, usePrevious, userData, setActiveMenuId, GetTimeActivity } = useContext(contentContext);


    const styles = {
        container: {
            display: "flex",
            flexWrap: "wrap",
            padding: "5px",
            border: "1px solid #ccc",
            borderRadius: "6px",
            maxWidth: "400px"
        },
        tag: {
            display: "flex",
            alignItems: "center",
            background: "#e0e0e0",
            padding: "5px 10px",
            margin: "5px",
            borderRadius: "4px"
        },
        remove: {
            marginLeft: "8px",
            cursor: "pointer",
            color: "#888"
        },
        input: {
            flex: 1,
            border: "none",
            outline: "none",
            minWidth: "100px",
            padding: "5px",
            margin: "5px"
        }
    };

    const prevRoute = usePrevious(route)
    useEffect(() => {
        if (prevRoute !== undefined && prevRoute !== route) {
            setCurrentPage(1)
            setRowsPerPage(15)
        }
    }, [prevRoute]);


    useEffect(() => {
        // console.log("imageFiles ,uploadedFiles, ", imageFiles, imageIndex, uploadedFiles)
        if (imageFiles && imageFiles?.length > 0 && uploadedFiles && uploadedFiles?.length > 0 && uploadedFiles?.length == imageFiles?.length ) {
           // updateFilesAPI()
        }
    }, [uploadedFiles]);


    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                    setimageCloudfront(window.site.common.imageCloudfront)
                    setResourceImg(window.site.common.resourceBucket)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            console.log('window.site.common', window.site.common)
            setImg(window.site.common.imageCloudfront)
            setimageCloudfront(window.site.common.imageCloudfront)
            setResourceImg(window.site.common.resourceBucket)
        }


    }, [window.site]);

    useEffect(() => {
        if (toastMessage) {
            toast.success(toastMessage, {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            // Clear the message after showing to prevent re-triggering
            setToastMessage("");
        }
    }, [toastMessage]);

    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/");
        }
        setActiveMenuId(200005)
        setActiveMenuObj({
            "Client Management": false,
            "Contact Management": false,
            "Reports": false
        })
        setRoute("user")
        if (id) {
            getuser();


        }
        getCpcInfo()
        GetAnswersInfo()
        // getManagers();
        //  GetCountries();
        // userActivity();
    }, []);
    const GetAnswersInfo = async () => {
        try {
            
            const response = await tmdbApi.casesInfo();
            if (typeof response?.result === 'object') {
                let ans = response?.result || [];
                if (ans.length > 0) {
                    let tmpArr = [];
                    ans.forEach(a => {
                        let obj = {
                            value: `${a.caseid}`,
                            label: a.diagnosis
                        }
                        tmpArr.push(obj)
                    })
                    setAnswersData(tmpArr);

                    setFilteredOptionsMap({
                        cases: tmpArr
                    })


                }

            }
        } catch {
            console.log("error");
        }
    };


    useEffect(() => {
        if (!viewerRef.current) return;

        console.log("Loading OpenSeadragon with URL:", dziUrl);
        const isDziURL = dziUrl.includes("output.dzi");
        const { width, height } = imageDimensions; // Destructure imageDimensions for clarity


        const tileSource = isDziURL
            ? {
                Image: {
                    xmlns: "http://schemas.microsoft.com/deepzoom/2008",
                    Url: encodeURI(dziUrl),
                    Format: "jpeg",
                    Overlap: 2,
                    TileSize: 256,
                    Size: { Width: width, Height: height },
                },
            }
            : {
                type: "image",
                url: encodeURI(dziUrl),
                buildPyramid: false,
            };

        const osdViewer = OpenSeadragon({
            id: "openseadragon-viewer",
            prefixUrl: "https://openseadragon.github.io/openseadragon/images/",
            tileSources: tileSource,
            showNavigator: true,
            crossOriginPolicy: "Anonymous",
            navigatorPosition: "BOTTOM_RIGHT",
            maxZoomPixelRatio: 10,
            minZoomImageRatio: 0.5,
            visibilityRatio: 1,
            zoomPerScroll: 2,
            homeFillsViewer: true,
            gestureSettingsMouse: {
                clickToZoom: true,
                dblClickToZoom: true,
                flickEnabled: true,
                pinchToZoom: true,
                scrollToZoom: true,
            },
            showZoomControl: true,
            showHomeControl: true,
            showFullPageControl: true,
            showRotationControl: true,
            wrapHorizontal: false,
        });


        setViewer(osdViewer);

        return () => {
            if (osdViewer) {
                osdViewer.destroy();
            }
        };
    }, [dziUrl, imageDimensions]);
    const rotateImage = (angle) => {
        if (viewer) {
            const newRotation = (rotation + angle) % 360;
            viewer.viewport.setRotation(newRotation);
            setRotation(newRotation);
        }
    };

    const resetZoom = () => {
        if (viewer) {
            viewer.viewport.goHome();
            viewer.viewport.setRotation(0);
            setRotation(0);
        }
    };

    const closeDeepZoom = () => {
        setPopupOpen(false);
        setDziUrl("");
        setDziUrlFile("");
        setImageDimensions({ width: 0, height: 0 });
        if (viewer) {
            viewer.destroy();
            setViewer(null);
        }
    };



    const getCpcInfo = async () => {
        const response = await tmdbApi.cpcInfo("ACTIVE,UPCOMING");

        if (response?.result?.length > 0) {
            setCPCInfo(response?.result)
        }
    }

    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = id !== undefined ? path[path.length - 2] : path[path.length - 1];;
        var presentTime = moment();
        let payload;

        payload = {
            "userid": localStorage.getItem("userId"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };


        const previousId = localStorage.getItem("previousid");
        const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    localStorage.setItem("previousid", response?.data?.result)
                }
            });
    }


    const getuser = (e) => {
        GetTimeActivity()
        const userId = localStorage.getItem("userId")
        const token = localStorage.getItem("token")
        axios({
            method: 'POST',
            url: lambda + '/quizInfo?appname=' + appname + '&userid=' + userId + '&quizid=' + id + '&token=' + token,
        })
            .then(function (response) {
                //  console.log("response", response?.data?.result?.[0]);
                if (response?.data?.result === "Invalid token or Expired") {
                     setShowSessionPopupup(true)
                    // localStorage.clear();
                    // navigate("/")
                }
                else {
                    if (response?.data?.result.length > 0) {
                        setEditUser(response?.data?.result?.[0]);
                       // console.log(response?.data?.result, "ccssd s");
                        if(response?.data?.result?.[0]?.files && response?.data?.result?.[0]?.files?.length > 0){
                            let completedFiles = response?.data?.result?.[0]?.files.filter(file => file.dzistatus === "COMPLETED") || [];
                            setCompletedFiles(completedFiles)
                        }
                        


                        setTags(response?.data?.result?.[0]?.tags || [])
                        if (response?.data?.result?.[0] && response?.data?.result?.[0]?.permissions) {
                            setPermission(response?.data?.result?.[0]?.permissions)
                        }
                    } else {
                        setInvalidContent(true)
                    }
                }
                // getPermissions(response?.data && response?.data?.result && response?.data?.result?.[0] && response?.data?.result?.[0]?.type)
            });
    }

    const handleImageErrorDelete = (e, key) => {
        setImageErrorFiles(imageErrorFiles.filter(item => item.name !== key?.name));

    }

    const onclickInvalid = () => {
        GetTimeActivity()
        setInvalidContent(false)
        navigate('/')
    }

    const onDescriptionChange = (e, name) => {
        setEditUser((prevData) => ({
            ...prevData,
            [name]: e.target.value // Update the 'description' field with Quill editor value
        }));
        setInputChange(false)
    };

    const handleImageDelete = (e, key) => {
        let imgUrls = { ...imagesUrls }
        let imgIndex = imageIndex
        // console.log('imgIndex ', imgIndex)
        // console.log('imgIndex ', imgUrls[key]?.name)

        // let targetIndex = imageFiles.findIndex((each) => {each.name == imgUrls[key]?.name});
        // imageFiles.splice(targetIndex-1, 1);
        setImageFiles(imageFiles.filter(item => item.name !== imgUrls[key]?.name));

        // setImageFiles((imageFiles) => {
        //     return [
        //         ...imageFiles.filter((item, i) => item.name != imgUrls[key]?.name)
        //     ]
        // })

        if (imgUrls[key]) {
            delete imgUrls[key]
        }
        setImageUrls(imgUrls)
        setImageIndex(imgIndex - 1)

    }

    const handleImageFileDelete = async (e, item, key, type) => {
        // console.log("item ", item)
        setdeleteImage(true)
        let obj = item
        obj["index"] = key
        setDeleteImageId(item)
        setImageType(type)
    }

    const handleFileChange = async (event) => {
        const selectedFiles = Array.from(event.target.files);
        setInputChange(false)
        let filesLength = 0
        if (editUser && editUser?.files?.length > 0) {
            filesLength = filesLength + editUser?.files.length
        }
        if (imageFiles && imageFiles?.length > 0) {
            filesLength = filesLength + imageFiles?.length
        }
        if (selectedFiles && selectedFiles?.length > 0) {
            filesLength = filesLength + selectedFiles?.length
        }


        if (filesLength > 10) {
            setAlertPopup(true)
            return;
        }
        //for multiple files
        setImageDisplay(true)
        // setImageFiles(selectedFiles)
        // setImageFiles((prevData) => ([
        //     ...prevData, // Keep the other fields intact
        //     selectedFiles
        // ]));

        Array.from(selectedFiles).map(async (file, index) => {
            console.log('file', file)
            // console.log('setImageIndex ', imageIndex, index)
            let fileSize = 1048612 * 20 // 5MB
            // if (file?.size < fileSize) {
            if (imageIndex > 0) {
                index = index + imageIndex
            }
            let urlobj = URL.createObjectURL(file)
            // let img = new Image();
            // img.onload = function () {
            // alert(this.width + " " + this.height);
            // if (this.width < 3841) {
            // if (this.width < 2000) {


            setImageFiles((prevData) => ([
                ...prevData, // Keep the other fields intact
                file
            ]));

            setImageUrls((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["blob" + index]: {
                    url: urlobj,
                    name: file?.name
                }, // Update the changed field
            }));
            setImageIndex(index + 1)
            // } else {
            //     setFileSizeError(true)
            //     setFileSizeErrorMsg("Resolution has been greater than 3840px and 2160px")
            //     // let obj = {
            //     //     name: file?.name,
            //     //     size: file?.size,
            //     //     width: this.width,
            //     //     height: this.height,
            //     //     error: "Resolution has been greater then 3840px and 2160px",
            //     //     url: urlobj
            //     // }
            //     // setImageErrorFiles((prevData) => ([
            //     //     ...prevData, // Keep the other fields intact
            //     //     obj
            //     // ]));
            // }
            // };
            //  img.src = urlobj;
            // } else {
            //     setFileSizeError(true)
            //     setFileSizeErrorMsg("File size greater than 20MB")
            // }


        })

    };

    const handleClinicalImageDelete = (e, key) => {
        let imgUrls = { ...clinicalimagesUrls }
        let imgIndex = clinicalimageIndex

        setclinicalImageFiles(clinicalimageFiles.filter(item => item.name !== imgUrls[key]?.name));
        if (imgUrls[key]) {
            delete imgUrls[key]
        }
        setClinicalImageUrls(imgUrls)
        setClinicalImageIndex(imgIndex - 1)

    }

    const handleimageFileChange = async (event) => {
        const selectedFiles = Array.from(event.target.files);
        // console.log('ques', questionData?.files.length, imageFiles?.length, selectedFiles?.length)
        setInputChange(false)
        // let filesLength = 0
        // if (questionData && questionData?.files?.length > 0) {
        //     filesLength = filesLength + questionData?.files.length
        // }
        // if (imageFiles && imageFiles?.length > 0) {
        //     filesLength = filesLength + imageFiles?.length
        // }
        // if (selectedFiles && selectedFiles?.length > 0) {
        //     filesLength = filesLength + selectedFiles?.length
        // }

        // //  console.log('filesLength ', filesLength)
        // if (filesLength > 10) {
        //     setAlertPopup(true)
        //     return;
        // }


        Array.from(selectedFiles).map(async (file, index) => {
            // File size enable
            let fileSize = 1048612 * 20 // 20MB
            if (file?.size < fileSize) {
                if (clinicalimageIndex > 0) {
                    index = index + clinicalimageIndex
                }
                console.log("index", index)
                let urlobj = URL.createObjectURL(file)
                let img = new Image();
                img.onload = function () {
                    setclinicalImageFiles((prevData) => ([
                        ...prevData, // Keep the other fields intact
                        file
                    ]));

                    setClinicalImageUrls((prevData) => ({
                        ...prevData, // Keep the other fields intact
                        ["blob" + index]: {
                            url: urlobj,
                            name: file?.name
                        }, // Update the changed field
                    }));
                    setClinicalImageIndex(index + 1)
                };
                img.src = urlobj;
            } else {
                setFileSizeError(true)
                setFileSizeErrorMsg("File size greater than 20MB")
            }


        })

    };

    const handleKeyDown = (e) => {
        if ((e.key === "Enter" || e.key === ",") && input.trim()) {
            e.preventDefault();
            const newTag = input.trim();
            if (tags && !tags.includes(newTag)) {
                setTags([...tags, newTag]);
            }
            setInput("");
        }
        if (e.key === "Backspace" && input === "" && tags.length > 0) {
            e.preventDefault();
            const updatedTags = [...tags];
            const lastTag = updatedTags.pop();
            setTags(updatedTags);
            setInput(lastTag);
        }
    };

    const removeTag = (indexToRemove) => {
        setTags(tags.filter((_, index) => index !== indexToRemove));
    };



    const handleClickContainer = () => {
        inputRef.current.focus();
    };



    const handleFileUpload = async (clinicalimageFiles, quizid) => {
        // setUploadImg(true);

        if (clinicalimageFiles && clinicalimageFiles.length > 0) {
            let filesArray = [];

            // Convert all file uploads into an array of promises
            const uploadPromises = Array.from(clinicalimageFiles).map(async (file) => {
                const timestamp = Date.now();
                const fileExtension = file?.name?.split('.').pop();
                const ObjectID = require("bson-objectid");
                const uniqueId = new ObjectID().toString();

                let uploadFilePath;
                let bucket;

                if (file.type.startsWith('image/')) {
                    let filenameReplace = file.name.replace(/ /g, "_");
                    //uploadFilePath = `${appname}/${caseid}/${filenameReplace.split('.')[0]}_image_${timestamp}.${fileExtension}`;
                    const ObjectID = require("bson-objectid");
                    const uniqueId = new ObjectID().toString();
                    const fileNameUnique = `${uniqueId}_image_${timestamp}.${fileExtension}`;
                    const uploadFilePath = `${appname}/${quizid}/${uniqueId}/${fileNameUnique}`;


                    bucket = window.site && window.site.common && window.site.common.resourceBucket;

                    const data = {
                        source_bucket: bucket,
                        sourcepath: uploadFilePath
                    };

                    const newFile = {
                        filename: filenameReplace.split('.')[0],
                        sourcepath: uploadFilePath,
                        fileid: uniqueId,
                        filetype: file.type,
                        filesize: file.size,
                        fileformat: fileExtension
                    };

                    filesArray.push(newFile);

                    setFiles((files) => [...files, newFile]);

                    try {
                        // Get Upload URL
                        const uploadUrlResponse = await axios.post(
                            `${lambda}/uploadFiles?appname=${appname}&quizid=${quizid}`,
                            data,
                            { headers: { 'Content-Type': 'application/json' } }
                        );

                        if (uploadUrlResponse.data && uploadUrlResponse.data.result) {
                            const uploadUrl = uploadUrlResponse.data.result;

                            // Upload file to S3
                            const uploadResponse = await axios.put(uploadUrl, file, {
                                headers: {
                                    'Content-Type': file.type,
                                    'Cache-Control': 'no-cache'
                                }
                            });

                            if (uploadResponse.status === 200) {
                                return true; // Successfully uploaded
                            } else {
                                throw new Error('Failed to upload file to S3');
                            }
                        } else {
                            throw new Error('Failed to get upload URL');
                        }
                    } catch (error) {
                        console.error('File upload error:', error);
                        return false;
                    }
                }
            });

            try {
                //const results = await Promise.all(uploadPromises);
                await Promise.all(uploadPromises);

            } catch (error) {
                console.error('Error during file upload:', error);
            }
        }
    };

    const createProgressToast = (fileName) => {
        let progressToastId = toast(`Uploading ${fileName}...`, {
            progress: 0,
            closeOnClick: false,
            autoClose: false,

        });

        return progressToastId;
    };

    // Function to update progress toast
    const updateProgressToast = (toastId, progress) => {
        toast.update(toastId, {
            progress: progress / 100,
        });
    };

    // Function to close and show success or error message
    const finalizeToast = (toastId, fileName, success = true) => {
        toast.update(toastId, {
            render: success ? `${fileName} uploaded successfully!` : `${fileName} failed to upload.`,
            type: success ? 'success' : 'error',  // Using 'success' and 'error' as strings
            autoClose: 2000,
            closeOnClick: true,
        });

    };

    const handleUploadfunction = async (files, caseid) => {

        if (files && files.length > 0) {
            const uploadPromises = Array.from(files).map(async (file) => {
                const timestamp = Date.now();
                const fileExtension = file?.name?.split('.').pop();
                const clientid = localStorage.getItem('clientid');
                const token = localStorage.getItem('token');
                const ObjectID = require("bson-objectid");

                const uniqueId = new ObjectID().toString();
                let uploadFilePath;
                let bucket;
                // console.log("filesssss ", file)
                // Check the file type
                if (file) {
                    // File is a video
                    // uploadFilePath = `${clientid}/files/${uniqueId}_video_${timestamp}.${fileExtension}`;
                    bucket = window.site && window.site.common && window.site.common.resourceBucket; // Use source bucket for videos
                    // videoUploadFunction(uploadFilePath,bucket)
                    const timestamp = Date.now();
                    const fileExtension = file?.name?.split('.').pop();
                    const clientid = localStorage.getItem('clientid');

                    const ObjectID = require("bson-objectid");
                    const uniqueId = new ObjectID().toString();
                    const uploadFilePath = `${appname}/${caseid}/${uniqueId}/`;
                    const fileNameUnique = `${uniqueId}_image_${timestamp}.${fileExtension}`;


                    const uploaderOptions = {
                        file: file,
                        baseURL: baseUrl,
                        chunkSize: partsize,
                        threadsQuantity: numuploads,
                        useTransferAcceleration: ta,
                        bucket: uploadFilePath,
                        fileNameUnique: fileNameUnique,
                        sourceBucket: bucket
                    };

                    let percentage = undefined;
                    setPgvalue(0);
                    setPerf("-");
                    const uploader = new Uploader(uploaderOptions);
                    const tBegin = performance.now();
                    //console.log('tBegin', tBegin);

            
                    const newFile = {
                        fileCreated: new Date(),
                        filename: fileNameUnique,
                        sourcepath: uploadFilePath+fileNameUnique,
                        fileid: uniqueId,
                        originalFilename: file.name,
                        uploadStatus: "INPROGRESS"
                    };
                    console.log('newwww ', newFile)
                    setUploadedFiles((uploadedFiles) => [...uploadedFiles, newFile]);

                    //const progressToastId = createProgressToast(file.name);

                    // uploader
                    //     .onProgress(({ percentage: newPercentage }) => {
                    //         // Avoid logging the same percentage twice
                    //         if (newPercentage !== percentage) {
                    //             percentage = newPercentage;
                    //             setPgvalue(percentage);
                    //             //updateProgressToast(progressToastId, percentage);

                    //             if (percentage === 100) {
                    //                 setPerf((performance.now() - tBegin) / 1000);
                    //             }
                    //         }
                    //     })
                    //     .onError((error) => {
                    //         console.error(error);
                    //        // finalizeToast(progressToastId, file.name, false);
                    //     });

                    uploader.start();


                } else {
                    // File type is neither image nor video
                   // toast.error('Unsupported file type');
                    return;
                }
                //  console.log('Upload File Path:', uploadFilePath);

            });

            try {
                //const results = await Promise.all(uploadPromises);
                await Promise.all(uploadPromises);

                

            } catch (error) {
                console.error('Error during file upload:', error);
            }
        }

    };
    const handlePopupImage = (imageUrl) => {
        setShowImagePopup(true)
        setPopupImage(imageUrl)
    }

    const updateFilesAPI = () => {
        // console.log('uploadedFi2222 ', uploadedFiles)
        let payload = {
            files: uploadedFiles
        }

        payload["caseid"] = caseIdDynamic

        axios({
            method: 'POST',
            url: lambda + "/updateLearningCase?appname=" + appname + '&caseid=' + caseIdDynamic,
            data: payload,
        })
            .then(function (response) {
                   
                   
            });
    }


    // const handleChange = (e) => {
    //     console.log('typeeeeeeeeee', e.target.value)
    //     console.log('nameeeee', e.target.name)
    //     if (e.target.name === "userType") {
    //         if (id) {
    //             setCheckStatus(true);
    //         }
    //         // getPermissions(e.target.value);
    //         setEditUser({ ...editUser, [e.target.name]: e.target.value });

    //     } else if (e.target.name === "manager") {
    //         for (let key in manager) {
    //             if (manager.hasOwnProperty(key) && manager[key].userid === e.target.value) {
    //                 setEditUser({ ...editUser, [e.target.name]: e.target.value })
    //             }

    //         }

    //     } else if (e.target.name === "status") {
    //         if (id) {
    //             setCheckStatus(true);
    //         }
    //         setEditUser({ ...editUser, [e.target.name]: e.target.value });
    //     } else {
    //         setEditUser({ ...editUser, [e.target.name]: e.target.value });
    //     }



    // }
    const handleChange = (e) => {
        const { name, value } = e.target;


        if (name === "usertype") {
            if (id) {
                setCheckStatus(true);
            }
            setEditUser(prev => ({ ...prev, [name]: value }));
        }



        if (name === "phone") {
            let formattedValue = value;
            let numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters
            const currentIdc = editUser?.idc?.trim(); // Remove unnecessary spaces

            if (currentIdc === "USA") {
                console.log("Using USA Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 6) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3, 6)}-${numericValue.slice(6)}`;
                } else if (numericValue.length > 3) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`;
                } else {
                    formattedValue = numericValue;
                }
            } else if (currentIdc === "IND") {
                console.log("Using India Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 5) {
                    formattedValue = `${numericValue.slice(0, 5)}-${numericValue.slice(5)}`;
                } else {
                    formattedValue = numericValue;
                }
            }

            // Update the phone number only
            setEditUser(prev => ({ ...prev, phone: formattedValue }));
            return; // Stop further execution for "phone" field
        }

        else if (name === "manager") {
            for (let key in manager) {
                if (manager.hasOwnProperty(key) && manager[key].userid === value) {
                    setEditUser(prev => ({ ...prev, [name]: value }));
                    break; // No need to continue looping after finding the match
                }
            }
        }

        else if (name === "status") {
            if (id) {
                setCheckStatus(true);
            }
            setEditUser(prev => ({ ...prev, [name]: value }));
        } else if (name == "assignedCpc") {
            let assignedCpcValue = value.split("|")
            console.log("valddd ", value, assignedCpcValue[0], assignedCpcValue[1])
            setEditUser(prev => ({ ...prev, "assignedCpc": assignedCpcValue[0], "assignedCpcTitle": assignedCpcValue[1] }));
        } else {
            setEditUser(prev => ({ ...prev, [name]: value }));
        }
    };
    const handleChangeMultiSelect = (selected, key) => {
        setEditUser({ ...editUser, [key]: selected });

    }
    function onConfirm() {
        setSuccess(false);
        navigate("/quizzes")
    };

    function onUpdateConfirm() {
        setUpdateSuccess(false);
        getuser()

        if (imageFiles && imageFiles.length > 0) {
            setImageUrls(null);
            setImageFiles([])
            setImageIndex(0)
        }

        if (clinicalimageFiles && clinicalimageFiles.length > 0) {
            setClinicalImageUrls(null);
            setclinicalImageFiles([])
            setClinicalImageIndex(0)
        }

    };

    const handleAddUser = (e) => {
        GetTimeActivity()
        const isValid = formvalidation();
        if (isValid) {
            const quizid = uuid();
            // if (imageFiles && imageFiles.length > 0) {
            //   handleFileUpload(caseid, "create")
            // } else {
            createuser(imageFiles, quizid);
            //  }

        }
    }

    function formvalidation() {
        GetTimeActivity()
        let formIsValid = true;

        if (editUser?.quiz === undefined || editUser?.quiz?.trim() === "") {
            setQuizError("Please enter Quiz");
           // setTimeout(function () { setQuizError("") }, 3000);
            formIsValid = false;
        }else {
            setQuizError("")
        }

        if (editUser?.cost === undefined || editUser?.cost?.trim() === "") {
            setCostError("Please enter Cost");
           // setTimeout(() => settagError(""), 3000);
            formIsValid = false;
        }else {
            setCostError("")
        }

        // if (id && (editUser?.description === undefined || editUser?.description?.trim() === "")) {
        //     setdescriptionError("Please enter Description");
        //    // setTimeout(function () { setdescriptionError("") }, 3000);
        //     formIsValid = false;
        // }else {
        //     setdescriptionError("")
        // }

   

        return formIsValid;
    }


    const handleSubmit = (status) => {
        GetTimeActivity()
        setIsLoading(true)

        const token = localStorage.getItem("token")
        let payload = {}
        payload = {
            "quiz": editUser?.quiz,
            "description": editUser?.description,
            "status": editUser?.status,
            "cost": editUser?.cost,
            "cases":editUser?.cases,
        }

       
        payload["quizid"] = id
        const userId = localStorage.getItem("userId")

        axios({
            method: 'POST',
            url: lambda + "/updateQuiz?appname=" + appname + '&userid=' + userId + '&quizid=' + id,
            data: payload,
        })
            .then(function (response) {
                if (response) {
                    if (imageFiles && imageFiles?.length > 0) {
                        handleUploadfunction(imageFiles, id)
                    }
                    if (clinicalimageFiles && clinicalimageFiles?.length > 0) {
                        handleFileUpload(clinicalimageFiles, id)
                    }
                    setCaseId(id)
                    if (response?.result === "Invalid token or Expired") {
                         setShowSessionPopupup(true)
                        // localStorage.clear();
                        // navigate("/")
                    } else if (response?.data?.result === "This ACM assaigned to companies") {
                        setIsMsg(true);
                        setIsLoading(false);
                    } else {
                        setIsLoading(false);
                        setUpdateSuccess(true)
                        //setSuccessAPI(true)
                        setSuccessMsg("Updated Successfully")
                        //setToastMessage("Updated Successfully")

                         //if (id && imageFiles?.length == 0) {
                           // getuser();
                            

                         //}
                         setTimeout(() => {
                            // navigate("/quizzes"); // Trigger API call AFTER toast is displayed
                         }, 2000);
                    }
                }

            });
    }


    const handleUpdate = (e) => {
   
        const isValid = formvalidation();
        // if (imageFiles && imageFiles.length > 0) {
        //   handleFileUpload(id, "update")
        //  } else {
        if(isValid){
            handleSubmit();
        }
     
    }

    const createuser = async (imageFiles, quizid) => {
        setIsLoading(true)


        // GetTimeActivity()   
        let payload = {}
        payload = {
            "quiz": editUser?.quiz,
            "description": editUser?.description,
            "status": editUser?.status,
            "cost": editUser?.cost,
            "cases":editUser?.cases,
           
        }

        payload["quizid"] = quizid

       

        const userId = localStorage.getItem("userId")

        axios({
            method: 'POST',
            url: lambda + "/addQuiz?appname=" + appname + "&userid=" + userId,
            data: payload,
        })
            .then(function (response) {
                if (response) {
                    console.log("response?.resultimageFiles", response,  quizid)
                   
                    if (clinicalimageFiles && clinicalimageFiles?.length > 0) {
                        handleFileUpload(clinicalimageFiles, quizid)
                    }

                    setCaseId(quizid)

                    if (response?.data?.result === "User already exists") {
                        setIsLoading(false)
                        setExistMsg(true)

                    }
                    else if (response?.result === "Invalid token or Expired") {
                        setIsLoading(false)
                         setShowSessionPopupup(true)
                        // localStorage.clear();
                        // navigate("/")
                    }
                    else {
                        setIsLoading(false)
                        setSuccess(true);
                        
                        setSuccessMsg("Created Successfully")

                        // setToastMessage("Created Successfully")
                        //setTimeout(() => {
                           // navigate("/quizzes"); // Trigger API call AFTER toast is displayed
                        //}, 2000);
                    }
                }

            });

    };

    const handleBack = (e) => {
        GetTimeActivity()
        if (id) {
            navigate({
                pathname: "/quizzes",
                state: { search: true }
            });
        } else {
            navigate("/quizzes")
        }
    }

    const CancelClick = () => {
        GetTimeActivity()
        setIsMsg(false);
        navigate("/quizzes")
    }



    const handleSelectAll = (e, updatedType, menuItemIndex, submenuIndex) => {
        const checked = e.target.checked;
        // console.log('menuItemIndex',menuItemIndex)
        // console.log('submenuIndex',submenuIndex)
        setPermission(prevState => {
            if (submenuIndex === undefined) {
                return prevState.map((menuItem, i) => {
                    if (i === menuItemIndex) {
                        const updatedDashboard = Object.keys(menuItem.dashboard).reduce((obj, key) => {
                            obj[key] = { ...menuItem.dashboard[key], [updatedType]: checked };
                            return obj;
                        }, {});
                        return { ...menuItem, [updatedType]: checked, dashboard: updatedDashboard };
                    }
                    return menuItem;
                });
            } else if (submenuIndex === "submenus") {
                return prevState.map((menuItem, i) => {
                    if (i === menuItemIndex) {
                        // console.log('menuItem.submenus',menuItem.submenus)
                        const updatedSubmenus = menuItem.submenus.map((submenu, j) => {

                            const kk = Object.keys(submenu.dashboard).reduce((obj, key) => {
                                obj[key] = { ...submenu.dashboard[key], [updatedType]: checked };
                                return obj
                            }, {});

                            return { ...submenu, [updatedType]: checked, dashboard: kk };

                        });
                        return { ...menuItem, [updatedType]: checked, submenus: updatedSubmenus };

                    }
                    return menuItem;
                });
            }

            else {

                return prevState.map((menuItem, i) => {
                    if (i === menuItemIndex) {
                        const updatedSubmenus = menuItem.submenus.map((submenu, j) => {
                            if (j === submenuIndex) {

                                const kk = Object.keys(submenu.dashboard).reduce((obj, key) => {
                                    obj[key] = { ...submenu.dashboard[key], [updatedType]: checked };
                                    return obj
                                }, {});

                                return { ...submenu, [updatedType]: checked, dashboard: kk };
                            }
                            return submenu;
                        });
                        return { ...menuItem, submenus: updatedSubmenus };
                    }
                    return menuItem;
                });
            }
        });
        // console.log('permissionss',permission)
    };

    const handleChangeEachItem = (e, index, subIndex, type, typeOfItem, updatedType, subSubIndex) => {
        const updatedPermission = [...permission];
        const isChecked = e.target.checked;
        // console.log('typeeee',type)
        // console.log('index',index)
        // console.log('subIndex',subIndex)
        // console.log('updatedPermission',updatedPermission)
        // console.log('typeOfItem',typeOfItem)
        if (typeOfItem === 'dashboard') {
            updatedPermission[index].dashboard[type][updatedType] = isChecked;
        } else if (typeOfItem === 'submenus') {
            updatedPermission[index].submenus[subSubIndex].dashboard[type][updatedType] = isChecked;
            if (isChecked && updatedPermission[index].dashboard) {
                Object.keys(updatedPermission[index].dashboard).forEach(key => {
                    updatedPermission[index].dashboard[key][updatedType] = true;
                });
            }
        }

        setPermission(updatedPermission);
    };


    const handlePopupload = (e) => {
        setPopupLoading(true)
    }

    const imageFileDelete = async (e) => {
        setdeleteImage(false)
        try {
            let params = {
                "source_bucket": resourceBucket,
                "sourcepath": deleteImageId?.filepath,
                "fileid": deleteImageId?.fileid
            }

            if (deleteimageType == "file") {
                await tmdbApi.deleteHistoricFiles(id, params);
            } else {
                await tmdbApi.deleteOmeFiles(id, params);
            }


            setDeleteImageSuccess(true)
        } catch {
            console.log("error");
        }
    }

    const onDelImageCancel = (e) => {
        setdeleteImage(false)
        setDeleteImageId(null)

    }

    const ondeleteImageConfirm = (e) => {
        setDeleteImageSuccess(false)
        // let deleteImageIndex = deleteImageId["index"]
        // if (deleteImageIndex > -1) { // only splice array when item is found
        //     editUser["historyfiles"].splice(deleteImageIndex, 1); // 2nd parameter means remove one item only
        // }
        setDeleteImageId(null)
       // let imgIndex = clinicalimageIndex
       // setClinicalImageIndex(imgIndex - 1)
        getuser()
    }

    // console.log("imageFiles", imagesUrls, imageFiles);

    

    const handleSelectChange = (selectedOption, aIndex) => {
        setEditUser((prevData) => ({
            ...prevData,
            [aIndex]: selectedOption // Update the 'description' field with Quill editor value
        }));
    }

    const handleInputChange = (inputValue, aIndex) => {

        if (inputValue !== "") {
            const results = answers?.filter(option =>
                option.label.toLowerCase().includes(inputValue.toLowerCase())
            );
            setFilteredOptionsMap(prev => ({
                ...prev,
                [`${aIndex}`]: results
            }));
        } else {
            setFilteredOptionsMap(prev => ({
                ...prev,
                [`${aIndex}`]: answers
            }));
        }
    };

    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <SideMenu />
                {/* <SweetAlert show={invalidContent}
                    custom
                    confirmBtnText="ok"
                    confirmBtnBsStyle="primary"
                    title={"User Not Found"}
                    onConfirm={e => onclickInvalid()}
                >
                </SweetAlert> */}
                {!invalidContent &&

                    <div className="main-content user-management create-user" id="main-content">
                        <div className="page-content" id="page-content">
                            <div className="container-fluid" id="container-fluid">
                                <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                    <div className="col-lg-12">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-grow-1">
                                                <h4 className="mb-2 card-title" id="breadcrumb-title">{id === undefined ? "QUIZ" : "EDIT QUIZ"}</h4>
                                                <p className="menu-path" id="breadcrumb-path">
                                                    <span>Learning Hub</span> / <b id="breadcrumb-action">{id === undefined ? "ADD QUIZ" : "EDIT QUIZ"}</b>
                                                </p>
                                            </div>
                                            <div>
                                                <a id="back-button" onClick={handleBack} className="stroke-btn-style create-quiz-btn">back
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="create-user-block" id="create-user-block">
                                    {Object.keys(editUser)?.length > 0 ? (
                                        <>
                                            <div className="form-block" id="form-block">
                                                <div className="row">
                                                   
                                                        <div className="col-lg-12">

                                                            <div className="col-lg-6 col-md-12">
                                                                <div className="mb-3 input-field">
                                                                    <label className="form_label">QUIZ<span className="required">*</span></label>
                                                                    <input id="quiz" name="quiz" placeholder="Enter Quiz" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)} value={editUser?.quiz} />
                                                                    <span id="quiz-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{quizError}</span>
                                                                </div>
                                                            </div>


                                                            <div className="col-lg-12 col-md-12">
                                                                <div className="mb-3 input-field clinical-history">
                                                                    <label className="form-label form-label">Description
                                                                        {/* {id && <span className="required">*</span>} */}
                                                                        </label>

                                                                    <Editor name="description" value={editUser?.description} onChange={(e) => onDescriptionChange(e, 'description')} />

                                                                    <span id="description-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{descriptionError}</span>



                                                                </div>
                                                            </div>
                                                          

                                                                <div className="col-lg-6 col-md-12">
                                                                    <div className="mb-3 input-field">
                                                                        <label className="form_label">COST<span className="required">*</span></label>
                                                                        <input id="cost" name="cost" placeholder="Enter cost" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)} value={editUser?.cost} />
                                                                        <span id="cost-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{costError}</span>
                                                                    </div>
                                                                </div>
                                                               
                                                               
                                                                {/* } */}

                                                                <div className="col-lg-6 col-md-12">
                                                                    <div className="mb-3 input-field">
                                                                        <label className="form_label">Status</label>
                                                                        <select name="status" onChange={(e) => handleChange(e)}
                                                                            value={editUser?.status} className="form-control form-select">
                                                                            <option value="">Select status</option>
                                                                             <option value="ACTIVE">ACTIVE</option>
                                                                             <option value="INACTIVE">INACTIVE</option>
                                                                        </select>

                                                                    </div>
                                                                </div>

                                                           

                                                             <div className="col-lg-12 col-md-12">
                                                                    <div className="mb-3 input-field">
                                                                        <label className="form_label">Select Cases</label>

                                                                        <Select
                                                                            className="select"
                                                                            isMulti={true}
                                                                            placeholder="Select Cases"
                                                                            onChange={(option) => handleSelectChange(option, "cases")}
                                                                            onInputChange={(value) => handleInputChange(value, "cases")}
                                                                            options={filteredOptionsMap?.cases}
                                                                            isClearable
                                                                            value={editUser?.cases || null}
                                                                            components={customComponents}
                                                                        />


                                                                </div>
                                                            </div>


                                                            <div className="col-lg-12 mt-4">
                                                                {/* ── 1. CLINICAL HISTORY PHOTOS ─────────────────────── */}
                                                                <div className="col-md-12">
                                                                    <div className="d-flex col-lg-12 align-items-start justify-content-between">
                                                                        <label className="form_label col-3">UPLOAD IMAGES</label>
                                                                        <p className="mt-0 mb-0 text-muted col-8 file-format">Note: File size: 20 MB | Supported Formats: JPG, PNG</p>
                                                                    </div>

                                                                    <div className="d-flex justify-content-start col-lg-12 clinical-photo-section gap-3 mt-3">



                                                                        {/* Uploaded clinical images */}
                                                                        {/* THUMBNAIL GRID */}
                                                                        <div className="uploaded_images-grid mb-3 mt-2" /* grid container */>
                                                                            {/* ── Clinical images from local upload ─────────────────── */}
                                                                            <div className="upload-box">
                                                                                <div className="file_upload add-box">
                                                                                    <input
                                                                                        type="file"
                                                                                        id="file-upload"
                                                                                        accept="image/jpeg, image/png"
                                                                                        className="file-input"
                                                                                        //multiple
                                                                                        onChange={handleimageFileChange}
                                                                                        style={{ display: "none" }}
                                                                                    />
                                                                                    <label htmlFor="file-upload" className="Add-btn d-flex align-items-center justify-content-center flex-column">
                                                                                        <p className="mb-0">
                                                                                            <span className="material-symbols-outlined plus-icon">add</span>
                                                                                        </p>
                                                                                        ADD
                                                                                    </label>
                                                                                </div>
                                                                                {/* <div className="file_requirements mt-2 small text-muted">
                                                                                <p className="mb-1">File size: 20 MB</p>
                                                                                <p className="mb-0">Formats: JPG, PNG</p>
                                                                            </div> */}
                                                                            </div>

                                                                            {clinicalimagesUrls &&
                                                                                Object.keys(clinicalimagesUrls).map((item, key) => (
                                                                                    <div className="thumb-box" key={key}>
                                                                                        <div
                                                                                            className="thumb-img cursor-pointer"
                                                                                            onClick={() => handlePopupImage(clinicalimagesUrls[item].url)}
                                                                                        >
                                                                                            <img
                                                                                                src={clinicalimagesUrls[item].url}
                                                                                                alt="uploaded"
                                                                                            />

                                                                                            <span
                                                                                                className="icon-close"
                                                                                                onClick={(e) => {
                                                                                                    e.stopPropagation();
                                                                                                    handleClinicalImageDelete(e, item, key, "file");
                                                                                                }}
                                                                                            >
                                                                                                ×
                                                                                            </span>
                                                                                        </div>
                                                                                        {/* <p className="thumb-name text-truncate small mb-0">
                                                                                            {clinicalimagesUrls[item].name}
                                                                                        </p> */}
                                                                                    </div>
                                                                                ))}



                                                                            {/* ── Clinical images from editUser.historyfiles ─────────── */}
                                                                            {editUser?.files?.length > 0 &&
                                                                                editUser.files.map((item, key) => {
                                                                                    const imagePath = `${imageCloudfront}${item?.sourcepath?.replace(/ /g, '%20')
                                                                                        }?auto=compress,format`;
                                                                                    return (
                                                                                        <div className="thumb-box" key={key}>
                                                                                            <div
                                                                                                className="thumb-img cursor-pointer"
                                                                                                onClick={() => handlePopupImage(imagePath)}
                                                                                            >
                                                                                                <img src={`${imagePath}&width=150`} alt="history" />

                                                                                                <span
                                                                                                    className="icon-close"
                                                                                                    onClick={(e) => {
                                                                                                        e.stopPropagation();
                                                                                                        handleImageFileDelete(e, item, key, 'file');
                                                                                                    }}
                                                                                                >
                                                                                                    ×
                                                                                                </span>

                                                                                            </div>
                                                                                            {/* <p className="thumb-name text-truncate small mb-0">
                                                                                                {item.filename}
                                                                                            </p> */}
                                                                                        </div>
                                                                                    );
                                                                                })}
                                                                        </div>

                                                                    </div>
                                                                </div>

                                                              
                                                            </div>



                                                            <div>
                                                                {imageErrorFiles && imageErrorFiles.length > 0 && imageErrorFiles?.map((item, key) => {

                                                                    return (
                                                                        <div className="upload_images" key={key}>
                                                                            <div className="img">
                                                                                <img src={item?.url} />
                                                                                <p>{item?.error} </p>
                                                                            </div>
                                                                            <span onClick={(e) => handleImageErrorDelete(e, item)} className="material-symbols-outlined icon"> delete </span>
                                                                        </div>

                                                                    )
                                                                })}
                                                            </div>

                                                        </div>




                                                </div>
                                                
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 d-flex" >

                                                    {id &&  <button id="submit-button" className="fill-btn-style create-quiz-btn border-0" type="button" onClick={e => handleUpdate(e)}>Update
                                                    </button>}
                                                        

                                                    {id === undefined && <button id="submit-button" className="fill-btn-style create-quiz-btn border-0" type="button" onClick={e => handleAddUser(e)}>Save
                                                    </button>}

                                                </div>
                                                {msg && <span id="success-msg" className="errormsg" style={{ fontWeight: 'bold', color: 'green' }}>{msg}</span>}
                                            </div>
                                        </>
                                    ) : (
                                        <div className="form-block" id="loading-block">
                                            <div className="tab-content p-3 text-muted">
                                                <div className="tab-pane active show" id="home1" role="tabpanel">
                                                    <div className="row">
                                                        <Loader />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <Footer id="footer" />
                    </div>

                }


                {showImagePopup && (
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(0,0,0,0.8)",
                            zIndex: 1000,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                        onClick={() => setShowImagePopup(false)}
                    >
                        <div style={{ position: "relative", width: "80%", maxWidth: "500px" }}>
                            <img src={popupImage} style={{
                                maxWidth: "500px",
                                width: "100%",
                                height: "auto",
                                display: "block",
                                margin: "0 auto",
                            }} className="modal-img" />
                            <button
                                onClick={() => setShowImagePopup(false)}
                                className="create-quiz-btn border-0"
                                style={{
                                    position: "absolute",
                                    top: 10,
                                    right: 10,
                                    cursor: "pointer",
                                }}
                            >
                                X
                            </button>
                        </div>
                    </div>
                )}

            </div>



            {isPopupOpen && !dziUrl && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 999,
                    }}
                    onClick={() => setPopupOpen(false)}
                >
                    <div className="popup_wrp"
                        style={{
                            position: "relative",
                            background: "white",
                            padding: "10px",
                            borderRadius: "10px",
                            maxWidth: "90vw",
                            maxHeight: "90vh",

                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Close Button */}
                        <button
                            style={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                background: "white",
                                color: "#000",
                                border: "none",

                                cursor: "pointer",
                                borderRadius: "5px",
                            }}
                            onClick={() => setPopupOpen(false)}
                        >
                            <span className="material-symbols-outlined">
                                close
                            </span>
                        </button>

                        {/* Zoomable Image */}
                        <TransformWrapper ref={transformRef} initialScale={1}>
                            <div style={{ textAlign: "left", marginBottom: "10px" }}>
                                <button onClick={() => transformRef.current.zoomIn()} className="btnzoom" ><span className="material-symbols-outlined"> add </span></button>
                                <button onClick={() => transformRef.current.zoomOut()} className="btnzoom"><span className="material-symbols-outlined"> remove </span></button>
                                <button onClick={() => transformRef.current.resetTransform()} className="btnzoom"><span className="material-symbols-outlined"> refresh </span></button>
                            </div>

                            <TransformComponent>


                                {isPopupLoading && <div style={{ width: "400px", height: "400px" }}><Loader /> </div>}

                                <LazyLoadImage
                                    src={dzipopupImage + `? auto = compress, format`}
                                    effect="blur"
                                    onLoad={() => setPopupLoading(false)}
                                    style={{ width: "100%", borderRadius: "10px" }}
                                />

                            </TransformComponent>
                        </TransformWrapper>
                    </div>
                </div>
            )}

            {/* Deep Zoom Popup */}
            {isPopupOpen && dziUrl && (
                 <div className="deep_zoom">
                <div
                    style={{
                        position: "fixed",
                        top: '0',
                        left: '0',
                        right: '0',
                        bottom: '0',
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 999,
                        borderRadius: "18px"
                    }}
                >
                    <div style={{
                        width: "98vw",
                        height: "98vh",
                        position: "relative",
                        backgroundColor: "black",
                        overflow: "hidden"
                    }}>
                        {/* Deep Zoom Header */}
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "10px 20px",
                            backgroundColor: "#f8f9fa",
                            borderBottom: "1px solid #dee2e6"
                        }}>
                            <h3 style={{ fontSize: "18px" }}>
                                {/* {dziUrlFile ? dziUrlFile : ""} */}
                                </h3>
                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                {/* <button
                                    className="create-quiz-btn border-0"
                                    onClick={resetZoom}
                                >
                                    Reset View
                                </button> */}
                                {/* <button
                                    onClick={() => rotateImage(90)}
                                    className="create-quiz-btn border-0"

                                >
                                    Rotate 90°
                                </button> */}
                                <button
                                    className="dz_close"
                                    onClick={closeDeepZoom}
                                    style={{
                                        border: "none",
                                        fontWeight: "800",
                                    }}
                                >
                                    <span className="material-symbols-outlined">close</span>
                                </button>
                            </div>
                        </div>

                        {/* Deep Zoom Viewer Container */}
                        <div style={{
                            height: "calc(95vh - 80px)",
                            width: "100%",
                            position: "relative"
                        }}>
                            <div
                                id="openseadragon-viewer"
                                ref={viewerRef}
                                style={{
                                    height: "100%",
                                    width: "100%"
                                }}
                            />

                            {/* Instructions */}
                            {/* <div style={{
                                position: "absolute",
                                bottom: "20px",
                                left: "20px",
                                backgroundColor: "rgba(0, 0, 0, 0.7)",
                                color: "white",
                                padding: "10px",
                                borderRadius: "5px",
                                fontSize: "12px"
                            }}>
                                <p style={{ margin: "2px 0" }}>• Zoom with mouse wheel or pinch gesture</p>
                                <p style={{ margin: "2px 0" }}>• Pan by clicking and dragging</p>
                                <p style={{ margin: "2px 0" }}>• Use the navigator in the bottom-right for orientation</p>
                                <p style={{ margin: "2px 0" }}>• Use toolbar buttons to rotate or reset view</p>
                            </div> */}
                        </div>
                    </div>
                </div>
                </div>
            )}


            {dziUrl && (
                <section className="viewer-section">
                    <div className="viewer-header">
                        <h2>Deep Zoom Viewer</h2>
                        <div className="viewer-controls">
                            <button className="control-button" onClick={() => window.location.reload()}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 2v6h-6"></path>
                                    <path d="M3 12a9 9 0 0 1 15-6.7L21 8"></path>
                                    <path d="M3 22v-6h6"></path>
                                    <path d="M21 12a9 9 0 0 1-15 6.7L3 16"></path>
                                </svg>
                                <span>Reset</span>
                            </button>
                        </div>
                    </div>

                    <div className="viewer-container">
                        <div id="openseadragon-viewer" ref={viewerRef}></div>
                        <div className="viewer-instructions">
                            <p>• Zoom with mouse wheel or pinch gesture</p>
                            <p>• Pan by clicking and dragging</p>
                            <p>• Use the navigator in the bottom-right for orientation</p>
                        </div>
                    </div>
                </section>
            )}


            <ToastContainer
                id="toastContainer"
                position="bottom-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />

            {/* <SweetAlert
                show={uploadImg}
                title={"File Uploading......"}
                showConfirm={false} // Hides the OK button
            ></SweetAlert> */}


            <SweetAlert show={deleteImageSuccess}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={"Deleted Successfully"}
                onConfirm={e => ondeleteImageConfirm()}
            >
            </SweetAlert>

            <SweetAlert show={success}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={successMsg}
                onConfirm={e => onConfirm()}
            >
            </SweetAlert>

            <SweetAlert show={UpdateSuccess}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={successMsg}
                onConfirm={e => onUpdateConfirm()}
            >
            </SweetAlert>

            <SweetAlert show={deleteImage}
                warning
                showCancel
                confirmBtnText="Yes"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Are you sure you want to delete?"
                focusCancelBtn
                onConfirm={e => imageFileDelete(e)}
                onCancel={e => onDelImageCancel(e)}
            >
            </SweetAlert>

            <SweetAlert show={alertPopup}
                warning
                confirmBtnText="Ok"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Maximum 10 files allowed"
                focusCancelBtn
                onConfirm={e => setAlertPopup(false)}
            >
            </SweetAlert>

            <SweetAlert
                show={uploadImg}
                showConfirm={false}
                title=""
            //  onConfirm={() => setAlert(null)}
            >
                <div className="d-flex flex-column align-items-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">File Uploading...</span>
                    </div>
                    <p className="mt-3">File is Uploading...</p>
                </div>
            </SweetAlert>

            <SweetAlert show={fileSizeError}
                warning
                confirmBtnText="ok"
                confirmBtnBsStyle="danger"
                title={fileSizeErrorMsg}
                onConfirm={e => setFileSizeError(false)}
            >
            </SweetAlert>

        </>
    );
};

export default EditQuiz;